import React from "react";
import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
import { BusinessesLoadingDialog } from "./businesses-loading-dialog/BusinessesLoadingDialog";
import { BusinessDeleteDialog } from "./business-delete-dialog/BusinessDeleteDialog";
import { BusinessesDeleteDialog } from "./businesses-delete-dialog/BusinessesDeleteDialog";
import { BusinessesFetchDialog } from "./businesses-fetch-dialog/BusinessesFetchDialog";
import { BusinessesUpdateStatusDialog } from "./businesses-update-status-dialog/BusinessesUpdateStatusDialog";
import { BusinessesCard } from "./BusinessesCard";
import { BusinessesUIProvider } from "./BusinessesUIContext";
import * as uiHelpers from "./BusinessesUIHelpers";

function BusinessesDeleteDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <BusinessesDeleteDialog show={location.pathname === "/business/deleteBusinesses"} onHide={() => navigate("/business")} />;
}
function BusinessDeleteDialogRoute() {
  const navigate = useNavigate();
  const { id } = useParams();
  return <BusinessDeleteDialog show id={id} onHide={() => navigate("/business")} />;
}
function BusinessesFetchDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <BusinessesFetchDialog show={location.pathname === "/business/fetch"} onHide={() => navigate("/business")} />;
}
function BusinessesUpdateStatusDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <BusinessesUpdateStatusDialog show={location.pathname === "/business/updateStatus"} onHide={() => navigate("/business")} />;
}

export function BusinessesPage() {
  uiHelpers.initialFilter.filter.status = -1;
  const navigate = useNavigate();
  const businessesUIEvents = {
    newBusinessButtonClick: () => navigate("/business/new"),
    openEditBusinessPage: (id) => navigate(`/business/${id}/edit`),
    openDeleteBusinessDialog: (id) => navigate(`/business/${id}/delete`),
    openDeleteBusinessesDialog: () => navigate("/business/deleteBusinesses"),
    openFetchBusinessesDialog: () => navigate("/business/fetch"),
    openUpdateBusinessesStatusDialog: () => navigate("/business/updateStatus"),
  };

  return (
    <BusinessesUIProvider businessesUIEvents={businessesUIEvents}>
      <BusinessesLoadingDialog />
      <Routes>
        <Route path="deleteBusinesses" element={<BusinessesDeleteDialogRoute />} />
        <Route path=":id/delete" element={<BusinessDeleteDialogRoute />} />
        <Route path="fetch" element={<BusinessesFetchDialogRoute />} />
        <Route path="updateStatus" element={<BusinessesUpdateStatusDialogRoute />} />
      </Routes>
      <BusinessesCard />
    </BusinessesUIProvider>
  );
}
